import { Flex, View, Text, IconCheckMarkSolid } from '@smarterservices/smarter-ui';
import React from 'react';

const StatusItem = ({ label, completed }) => {
  return (
    <Flex
      as="div"
      direction="row"
      alignItems="center"
      gap="medium"
      margin="medium 0"
    >
      <View
        as="div"
        width="32px"
        height="32px"
        borderRadius="circle"
        borderWidth="small"
        borderColor={completed ? 'success' : 'secondary'}
        background={completed ? 'success' : 'transparent'}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {completed && <IconCheckMarkSolid color="primary-inverse" size="small" />}
      </View>
      <Text size="large" weight={completed ? 'bold' : 'normal'}>
        {label}
      </Text>
    </Flex>
  );
};

export default StatusItem;
